import React from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

import { RouteProp, useRoute } from '@react-navigation/native';

import ChatRoom from '../../components/chat/ChatRoom';
import { useUserContext } from '../../context/UserContext';
import { MessengerParamList } from '../../navigation/MessengerNav';

// all screen content must be in one KeyboardAvoidingView
const StyledContainer = styled.View`
  height: 100%;
  background-color: white;
`;

const StyledMarginTopContainer = styled.View<{
  backButtonContainerTopMargin: number;
}>`
  /* margin-top: ${p => p.backButtonContainerTopMargin}px; */
  height: 44px;
  width: 100%;
`;

const MessengerRoomScreen: React.FC = () => {
  const route = useRoute<RouteProp<MessengerParamList, 'MessengerRoom'>>();
  const roomId = route.params.roomId;
  const { user, updateUserSession } = useUserContext();
  const window = useWindowDimensions();
  const containerTopMargin =
    Platform.OS === 'web' ? (window.width >= 1440 ? 60 : 67) : 0;
  return (
    <StyledContainer>
      {Platform.OS === 'web' && (
        <StyledMarginTopContainer
          backButtonContainerTopMargin={containerTopMargin}
        ></StyledMarginTopContainer>
      )}
      {user && (
        <ChatRoom
          user={user}
          roomId={roomId}
          onTrackViewedMessages={() => {
            updateUserSession();
          }}
        />
      )}
    </StyledContainer>
  );
};

export default MessengerRoomScreen;
